import { SVGProps } from "react";

export const PaperIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 15 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.53946 0.869138C7.15551 0.619386 7.84462 0.619386 8.46068 0.869138L13.5734 2.94184C14.0236 3.12439 14.3182 3.56174 14.3182 4.04761V10.629C14.3182 11.1149 14.0236 11.5522 13.5734 11.7348L8.46068 13.8075C7.84462 14.0572 7.15551 14.0572 6.53946 13.8075L1.42678 11.7348C0.976503 11.5522 0.681885 11.1149 0.681885 10.629V4.04761C0.681885 3.56174 0.976503 3.12439 1.42678 2.94184L6.53946 0.869138ZM8.07643 1.81694C7.7068 1.66709 7.29333 1.66709 6.9237 1.81694L5.61891 2.34591L10.7508 4.34166L12.5708 3.63896L8.07643 1.81694ZM9.33491 4.88836L4.23738 2.90599L2.44799 3.63142L7.50097 5.59647L9.33491 4.88836ZM1.70461 10.629C1.70461 10.6984 1.7467 10.7609 1.81103 10.787L6.9237 12.8597C6.9453 12.8684 6.96706 12.8767 6.98894 12.8844V6.49469L1.70461 4.43967V10.629ZM8.07643 12.8597L13.1891 10.787C13.2534 10.7609 13.2955 10.6984 13.2955 10.629V4.45544L8.01167 6.49559V12.8842C8.03339 12.8766 8.05499 12.8684 8.07643 12.8597Z"
        fill="#1B645B"
      />
    </svg>
  );
};
